module.exports = __webpack_public_path__ + "img/siyi-chen-sun-shower.65e77c5.jpg";